import React from "react";

import { Button } from "@common/components/Button";
import { Flex } from "@common/components/Flex";
import { FormControl } from "@common/components/form-control";
import { Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter } from "@common/components/modal";

import { trDts } from "@modules/datasheets/utils/i18n";

import { DatasheetTabNameManagementProps } from "./tab-name-management.types";
import { useController } from "./tab-name-management.controller";

import { getTestAttributes } from "@common/utils/tests";

import "./tab-name-management.styles.scss";

export const DatasheetTabNameManagement: React.FC<DatasheetTabNameManagementProps> = (props) => {
  const { onClose } = props;

  const { tabName, handleTabSubmit, handleFormatNameChange, isAllowedToSubmit, modeConfig } = useController(props);

  return (
    <Modal
      show
      backdrop="static"
      bsSize="sm"
      bsClass="bootstrap modal"
      className="DatasheetTabNameManagement"
      dialogClassName="DatasheetTabNameManagement__dialog"
      animation={false}
      onEscapeKeyDown={onClose}
      onHide={onClose}
    >
      <ModalHeader closeButton onHide={onClose}>
        <ModalTitle {...getTestAttributes({ id: "fp-add-tab-wnd-panel" })}>{modeConfig.title}</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <Flex justify="center">
          <div className="DatasheetTabNameManagement__content">
            <div className="DatasheetTabNameManagement__inner">
              <span className="DatasheetTabNameManagement__field-label">{trDts("Tab name")}</span>
              <FormControl
                {...getTestAttributes({ id: "tx-add-tab-wnd-name" })}
                value={tabName}
                onChange={handleFormatNameChange}
              />
            </div>
          </div>
        </Flex>
      </ModalBody>
      <ModalFooter>
        <Flex justify="flex-end">
          <Button {...getTestAttributes({ id: "btn-add-tab-wnd-cancel" })} onClick={onClose}>
            {trDts("Cancel")}
          </Button>
          <Button
            {...getTestAttributes({ id: "btn-add-tab-wnd-create" })}
            disabled={
              !isAllowedToSubmit({
                tabName,
              })
            }
            bsStyle="primary"
            onClick={handleTabSubmit}
          >
            {trDts("OK")}
          </Button>
        </Flex>
      </ModalFooter>
    </Modal>
  );
};
